import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import { createContext } from 'react';
import { DefaultApi, ToiletApi } from '@/generated-sources/openapi';
export const AppComponentsContext = createContext({
    api: new DefaultApi(),
    toiletApi: new ToiletApi(),
});
export const AppComponentsProvider = ({ children, api, toiletApi, }) => {
    return (_jsx(AppComponentsContext.Provider, { value: { api, toiletApi }, children: children }));
};
